<wl-timer-widget
  [dateToCountDownTo]="content.dateToCountDownTo"
  [timerLabels]="content.timerLabels"
  [image]="content.timerWidgetImage"
  [title]="content.timerWidgetTitle"
  [text]="content.timerWidgetText"
/>
